// extracted by mini-css-extract-plugin
export default {"container":"ClinicalCourse_container__kRcow","iframe":"ClinicalCourse_iframe__NQrlc"};